import dayjs from "dayjs";
import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

import { UnauthorizedError } from "@/global";
import AccountModule from "@/store/modules/account";
import AuditEventModule, { AuditEventQueryParameter } from "@/store/modules/auditEvents";
import ConsentModule from "@/store/modules/consent";
import DocumentModule from "@/store/modules/document";
import HCProviderModule from "@/store/modules/hcprovider";
import VaccinationModule from "@/store/modules/vaccination";

const accountState = getModule(AccountModule);
const documentState = getModule(DocumentModule);
const vaccinationState = getModule(VaccinationModule);
const consentState = getModule(ConsentModule);
const logState = getModule(AuditEventModule);
const providerState = getModule(HCProviderModule);

@Component({})
export default class StateMixin extends Vue {
  clearUserData() {
    documentState.clearDocuments();
    vaccinationState.clearDocuments();
    consentState.clearConsent();
    logState.clearAuditEvents();
  }

  refetchCurrentResource() {
    if (this.$route.path.startsWith("/documents")) {
      documentState
        .fetchDocuments()
        .then(() => accountState.setNoAccessToThisEPD(false))
        .catch((error) => {
          if (error instanceof UnauthorizedError) {
            accountState.setNoAccessToThisEPD(true);
          } else {
            accountState.setNoAccessToThisEPD(false);
          }
        });
    } else if (this.$route.path.startsWith("/vaccinations")) {
      vaccinationState.fetchDocuments(true);
    } else if (this.$route.path.startsWith("/access-rights")) {
      consentState
        .fetchConsent(true)
        .then(() => providerState.fetchConsentHCPs(consentState.hcpSearchParameters))
        .then(() => accountState.fetchRepresentatives());
    } else if (this.$route.path.startsWith("/access-logs")) {
      // TODO: store parameters in state or URL and reapply them
      const queryParams: AuditEventQueryParameter = {
        startDate: dayjs().subtract(30, "days"),
        endDate: null,
        subtype: null,
        role: null,
      };
      logState.fetchAuditEvents(queryParams);
    } else if (accountState.isProfessionalUser) {
      this.$router
        .push({ name: "patients" })
        // Ignore duplicated navigation error
        .catch((err) => {
          if (err && err.name !== "NavigationDuplicated") {
            throw err;
          }
        });
    } else {
      this.$router.push({ name: "documents", params: { _reload: "true" } });
    }
  }
}
